"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAutocomplete = _interopRequireDefault(require("react-autocomplete"));

var _urijs = _interopRequireDefault(require("urijs"));

require("./gene-autocomplete.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TRANSITIONS = {
  standBy: 1,
  underEdit: 2,
  fetchingSuggestion: 3
};

var AutocompleteBox = /*#__PURE__*/function (_React$Component) {
  _inherits(AutocompleteBox, _React$Component);

  var _super = _createSuper(AutocompleteBox);

  function AutocompleteBox(props) {
    var _this;

    _classCallCheck(this, AutocompleteBox);

    _this = _super.call(this, props);
    _this.state = {
      value: "",
      currentTransition: TRANSITIONS.standBy,
      currentSuggestions: []
    };
    return _this;
  }

  _createClass(AutocompleteBox, [{
    key: "_requestSuggestions",
    value: function _requestSuggestions(value) {
      var _this2 = this;

      if (this.state.currentTransition === TRANSITIONS.fetchingSuggestion) {
        var httpRequest = new XMLHttpRequest();

        httpRequest.onload = function (e) {
          var xhr = e.target;
          var results = xhr.responseType === "json" ? xhr.response : JSON.parse(xhr.responseText);

          _this2.setState({
            currentSuggestions: results.filter(function (item) {
              return !_this2.props.valuesToSkipInSuggestions.includes(item.term);
            }),
            currentTransition: TRANSITIONS.underEdit
          });
        };

        httpRequest.open("GET", this.props.geneSuggesterUri.search({
          query: value
        }), true);
        httpRequest.responseType = "json";
        httpRequest.send();
      }
    }
  }, {
    key: "_renderItem",
    value: function _renderItem(item, isHighlighted) {
      var innerHtml = {
        __html: item.category ? "".concat(item.term, " (").concat(item.category, ")") : item.term
      }; // Background colour should match .button.primary colour in theme-atlas.css

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "menu-element",
        style: isHighlighted ? {
          background: "#3497c5",
          color: "white"
        } : {},
        key: "".concat(item.term, " ").concat(item.category),
        id: item.term
      }, /*#__PURE__*/_react["default"].createElement("span", {
        dangerouslySetInnerHTML: innerHtml
      }));
    }
  }, {
    key: "_isTooShortToShowHints",
    value: function _isTooShortToShowHints(value) {
      return !value || value.length < 3;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "padding-top-large gene-autocomplete " + (this.state.currentTransition === TRANSITIONS.underEdit || this.state.currentTransition === TRANSITIONS.fetchingSuggestion ? "underEdit" : this.state.currentTransition === TRANSITIONS.standBy ? "standBy" : "")
      }, /*#__PURE__*/_react["default"].createElement(_reactAutocomplete["default"], {
        open: this.state.currentTransition === TRANSITIONS.underEdit || this.state.currentTransition === TRANSITIONS.fetchingSuggestion,
        onMenuVisibilityChange: function onMenuVisibilityChange() {},
        inputProps: {
          name: "Enter gene",
          id: "gene-autocomplete",
          type: "text"
        },
        value: this.state.value,
        items: this.state.currentSuggestions,
        getItemValue: function getItemValue(item) {
          return item.term;
        },
        wrapperStyle: {
          display: "block"
        },
        onSelect: function onSelect(value, item) {
          _this3.setState({
            value: "",
            currentSuggestions: [],
            currentTransition: TRANSITIONS.standBy
          }, function () {
            _this3.props.onGeneChosen(item);
          });
        },
        onChange: function onChange(event, value) {
          if (_this3._isTooShortToShowHints(value)) {
            _this3.setState({
              value: value,
              currentTransition: TRANSITIONS.underEdit
            });
          } else {
            _this3.setState({
              value: value,
              currentTransition: TRANSITIONS.fetchingSuggestion
            }, function () {
              _this3._requestSuggestions(value);
            });
          }
        },
        renderMenu: function renderMenu(items, value, style) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "menu",
            style: {}
          }, _this3._isTooShortToShowHints(value) ? false : _this3.state.currentTransition === TRANSITIONS.fetchingSuggestion ? /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              padding: 6,
              "float": "bottom"
            }
          }, "Loading...") : /*#__PURE__*/_react["default"].createElement("div", null, items));
        },
        renderItem: this._renderItem
      }));
    }
  }]);

  return AutocompleteBox;
}(_react["default"].Component);

AutocompleteBox.propTypes = {
  geneSuggesterUri: _propTypes["default"].instanceOf(_urijs["default"]),
  onGeneChosen: _propTypes["default"].func.isRequired,
  valuesToSkipInSuggestions: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired
};
var _default = AutocompleteBox;
exports["default"] = _default;